import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StatusText from '../../../elements/StatusText';

const StyledStatusText = styled(StatusText)`
  padding-top: 0;
  text-align: right;
`;

const StatusMessage = ({ status }) => (
  <StyledStatusText modifiers={[status.type]}>{status.message}</StyledStatusText>
);

StatusMessage.propTypes = {
  status: PropTypes.shape({
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['error', 'success']).isRequired,
  }).isRequired,
};

export default StatusMessage;
